/* src/pages/ChangePasswordPage.tsx */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import LanguageSwitch from "../components/LanguageSwitch";
import "../styles/ChangePasswordPage.css";

export default function ChangePasswordPage() {
  const { t } = useTranslation<"translation">();
  const { user, setUser } = useAuth();
  const nav = useNavigate();

  const [oldPwd, setOld] = useState("");
  const [nextPwd, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [errorMsg, setError] = useState("");

  if (!user) return null;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (nextPwd !== confirm) {
      setError(t<string>("changePassword.error.noMatch"));
      return;
    }

    try {
      await api.post(
        "/auth/change-password",
        { old: oldPwd, next: nextPwd, confirm },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );

      setUser({ ...user, mustChangePwd: false });
      nav("/", { replace: true });
    } catch (err: any) {
      setError(err.response?.data?.message ?? t("common.error"));
    }
  };

  return (
    <div className="allcenter">
      <form onSubmit={submit} className="center2">
        <div className="contenedor">
          <div className="titulillo">
            {" "}
            <h2 className="text-lg font-semibold">{t("changePassword.title")}</h2>
            <div className="center">
              <LanguageSwitch />
            </div>
          </div>

          <div className="prueba">
            <p>
              Para reestablecer tu contraseña, introduce el email que utilizaste para crear tu
              cuenta. Te enviaremos un enlace para que puedas recuperar tu cuenta al siguiente
              correo electrónico:
            </p>
          </div>

          <div className="recuadros">
            <input
              className="input-field"
              type="password"
              placeholder={t<string>("changePassword.fields.old")}
              value={oldPwd}
              onChange={(e) => setOld(e.target.value)}
              autoComplete="current-password"
            />

            <input
              className="input-field"
              type="password"
              placeholder={t<string>("changePassword.fields.new")}
              value={nextPwd}
              onChange={(e) => setNext(e.target.value)}
              autoComplete="new-password"
            />

            <input
              className="input-field"
              type="password"
              placeholder={t<string>("changePassword.fields.repeat")}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
            />

            {errorMsg && <p className="text-red-500 text-sm">{errorMsg}</p>}

            <button type="submit" className="botoncito">
              {t("changePassword.btn")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
